/* Decottaa teması – ürün önerileri (Product Recommendations API, görünür olunca yüklenir). */
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if ($('.product-grid', this) || !this.dataset.url) return;
      const load = async () => {
        try {
          const response = await fetch(this.dataset.url);
          const fresh = $('product-recommendations', parseHTML(await response.text()));
          if (fresh && $('.product-grid', fresh)) {
            this.innerHTML = fresh.innerHTML;
            document.dispatchEvent(new CustomEvent('theme:content'));
          }
        } catch (error) {
          /* öneri yoksa bölüm boş kalır */
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              observer.disconnect();
              load();
            }
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(this);
      } else {
        load();
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
